<template>
  <div class="popularScienceVideoDetail">
    <div class="popularScienceVideoDetail_box" v-if="detailVideo.id">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/popularScienceVideo' }">
          视频
        </el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="video_player">
        <div class="video_player_info">
          <div class="left player_item">
            <div class="title">
              {{ detailVideo.title }}
            </div>

            <div class="video_box" v-if="detailVideo.video_url">
              <video
                controls
                :poster="
                  detailVideo.cover_img
                    ? detailVideo.cover_img
                    : 'https://doc.medsky.cn/uploadArticle/videoDefult.png'
                "
                width="100%"
                height="100%"
              >
                <source
                  width="100%"
                  height="100%"
                  :src="detailVideo.video_url"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          <div class="right player_item">
            <div class="title">相关视频</div>
            <div
              class="recommend_video_list scrollBar"
              v-if="
                detailVideo.recommend_video_list &&
                detailVideo.recommend_video_list.length
              "
            >
              <div
                class="recommend_video_item"
                v-for="(item, index) in detailVideo.recommend_video_list"
                :key="index"
                @click="videoRecommend(item)"
              >
                <div class="left_video">
                  <div class="img_play">
                    <svg
                      t="1757401038539"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5915"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M512 42.666667C252.793333 42.666667 42.666667 252.793333 42.666667 512s210.126667 469.333333 469.333333 469.333333 469.333333-210.126667 469.333333-469.333333S771.206667 42.666667 512 42.666667z m196.546667 500.493333l-266.666667 176A37.333333 37.333333 0 0 1 384 688V336.033333a37.333333 37.333333 0 0 1 57.893333-31.16l266.666667 176a37.333333 37.333333 0 0 1 0 62.32z"
                        fill="#f6faff"
                        p-id="5916"
                      ></path>
                    </svg>
                  </div>
                  <img v-if="item.cover_img" :src="item.cover_img" />
                  <img v-else src="../../assets/image/videoDefult.png" />
                </div>
                <div class="right_font ellipsis_single_2">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <el-empty class="noEmpty" :image-size="120" v-else>
              <template #image>
                <img src="../../assets/image/noDate.png" />
              </template>
            </el-empty>
          </div>
        </div>

        <div class="video_info">
          <div class="left">
            <div class="author video_item">
              <span class="title">作者：</span>
              <span>{{ detailVideo.author }}</span>
            </div>
            <div class="video_item">
              <span>{{ detailVideo.video_create_time }}年</span>
            </div>
            <!-- <div class="video_item">
              <span class="icon">
                <svg
                  t="1756802009061"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5002"
                  width="20"
                  height="20"
                >
                  <path
                    fill="#ffffff"
                    d="M515.2 224c-307.2 0-492.8 313.6-492.8 313.6s214.4 304 492.8 304 492.8-304 492.8-304S822.4 224 515.2 224zM832 652.8c-102.4 86.4-211.2 140.8-320 140.8s-217.6-51.2-320-140.8c-35.2-32-70.4-64-99.2-99.2-6.4-6.4-9.6-12.8-16-19.2 3.2-6.4 9.6-12.8 12.8-19.2 25.6-35.2 57.6-70.4 92.8-102.4 99.2-89.6 208-144 329.6-144s230.4 54.4 329.6 144c35.2 32 64 67.2 92.8 102.4 3.2 6.4 9.6 12.8 12.8 19.2-3.2 6.4-9.6 12.8-16 19.2C902.4 585.6 870.4 620.8 832 652.8z"
                    p-id="5003"
                  ></path>
                  <path
                    fill="#ffffff"
                    d="M512 345.6c-96 0-169.6 76.8-169.6 169.6 0 96 76.8 169.6 169.6 169.6 96 0 169.6-76.8 169.6-169.6C681.6 422.4 604.8 345.6 512 345.6zM512 640c-67.2 0-121.6-54.4-121.6-121.6 0-67.2 54.4-121.6 121.6-121.6 67.2 0 121.6 54.4 121.6 121.6C633.6 582.4 579.2 640 512 640z"
                    p-id="5004"
                  ></path>
                </svg>
              </span>
              <span>{{ detailVideo.click_num }}</span>
            </div> -->
          </div>
          <div class="right">
            <!-- <div class="video_item">
              <span class="icon">
                <svg
                  t="1756282150332"
                  class="icon"
                  viewBox="0 0 1058 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5428"
                  width="20"
                  height="20"
                >
                  <path
                    d="M242.036364 1014.690909c-6.206061 0-12.412121 0-18.618182-3.10303-15.515152-6.206061-27.927273-15.515152-37.236364-31.030303-6.206061-12.412121-9.309091-24.824242-6.20606-40.339394L229.624242 651.636364 21.721212 446.836364c-24.824242-24.824242-24.824242-62.060606 0-86.884849 9.309091-9.309091 21.721212-15.515152 34.133333-18.618182l288.581819-43.442424 130.327272-260.654545c6.206061-15.515152 18.618182-24.824242 37.236364-31.030303 15.515152-6.206061 31.030303-3.10303 46.545455 3.10303 12.412121 6.206061 21.721212 15.515152 27.927272 27.927273l130.327273 260.654545 288.581818 43.442424c34.133333 6.206061 55.854545 37.236364 52.751515 71.369697-3.10303 12.412121-9.309091 24.824242-18.618181 34.133334L831.612121 651.636364l49.648485 288.581818c3.10303 15.515152 0 34.133333-9.309091 46.545454s-24.824242 21.721212-40.339394 24.824243c-12.412121 3.10303-27.927273 0-40.339394-6.206061L527.515152 871.951515l-257.551516 136.533333c-9.309091 6.206061-18.618182 6.206061-27.927272 6.206061zM527.515152 71.369697l-142.739394 291.684848L62.060606 406.49697l232.727273 226.521212-55.854546 319.612121 288.581819-152.048485 288.581818 152.048485-55.854546-319.612121 232.727273-226.521212-319.612121-46.545455L527.515152 71.369697z"
                    fill="#ffffff"
                    p-id="5429"
                  ></path>
                </svg>
              </span>
              <span>收藏</span>
            </div> -->
            <!-- <div class="video_item">
              <span class="icon">
                <svg
                  t="1756282627140"
                  class="icon"
                  viewBox="0 0 1085 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="6547"
                  width="20"
                  height="20"
                >
                  <path
                    d="M546.904228 18.10573c-277.76918 0-502.94529 225.17611-502.94529 502.94529 0 277.77164 225.17488 502.94775 502.94529 502.94775 277.76795 0 502.94529-225.17611 502.94529-502.94775C1049.849518 243.28307 824.672178 18.10573 546.904228 18.10573L546.904228 18.10573zM546.904228 973.701659c-249.992631 0-452.651868-202.659237-452.651868-452.651868 0-249.990172 202.659237-452.649408 452.651868-452.649408s452.650638 202.659237 452.650638 452.649408C999.554866 771.042422 796.896859 973.701659 546.904228 973.701659L546.904228 973.701659zM775.203924 485.406478c-78.267962-53.25591-220.1919-132.967608-301.004232-182.358388-33.132146-20.893592-60.993549-12.502952-63.667043 24.399633-1.938099 98.840588 0 289.550264 0 390.101445 1.681079 37.462125 34.709926 42.403293 63.37559 27.362121 80.72133-48.906255 219.456505-132.95777 300.588574-182.112436C773.968017 562.476656 836.097862 528.305364 775.203924 485.406478L775.203924 485.406478z"
                    fill="#ffffff"
                    p-id="6548"
                  ></path>
                </svg>
              </span>
              <span>158</span>
            </div> -->
            <!-- <div class="video_item">
              <span class="icon">
                <svg
                  t="1756282681335"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7706"
                  width="20"
                  height="20"
                >
                  <path
                    d="M64 483.04V872c0 37.216 30.144 67.36 67.36 67.36H192V416.32l-60.64-0.64A67.36 67.36 0 0 0 64 483.04zM857.28 344.992l-267.808 1.696c12.576-44.256 18.944-83.584 18.944-118.208 0-78.56-68.832-155.488-137.568-145.504-60.608 8.8-67.264 61.184-67.264 126.816v59.264c0 76.064-63.84 140.864-137.856 148L256 416.96v522.4h527.552a102.72 102.72 0 0 0 100.928-83.584l73.728-388.96a102.72 102.72 0 0 0-100.928-121.824z"
                    p-id="7707"
                    fill="#ffffff"
                  ></path>
                </svg>
              </span>
              <span>9</span>
            </div> -->
          </div>
        </div>
      </div>

      <div class="video_detail">
        <div class="left">
          <div class="title">视频介绍</div>
          <div
            class="content rich-text-content scrollBar"
            v-html="detailVideo.remarks"
          ></div>
        </div>
        <div class="right">
          <img src="@/assets/image/组 1119@2x.png" />
          <div
            class="right-box"
            v-if="detailVideo.recommend_article_list.length != 0"
          >
            <ul class="right-box-ul">
              <li
                class="right-box-ul-li"
                v-for="(item, index) in detailVideo.recommend_article_list"
                :key="index"
                @click="$router.push('/detail?id=' + item._id)"
              >
                <div class="right-box-ul-li-img">
                  <img v-if="item.cover_img" :src="item.cover_img" />
                  <img v-else src="../../assets/image/dafute.png" />
                </div>
                <div class="right-box-ul-li-right">
                  <div class="right-box-ul-li-right-text">
                    {{ item.title }}
                  </div>
                  <div class="right-box-ul-li-right-bottom">
                    <div class="right-box-ul-li-right-bottom-zuo">
                      作者：{{ item.file_author_name }}
                    </div>
                    <!-- <div class="right-box-ul-li-right-bottom-num">
                      <div class="right-box-ul-li-right-bottom-num-img">
                        <img src="@/assets/image/icon/yan.png" />
                      </div>
                      <div class="right-box-ul-li-right-bottom-num-name">
                        {{ item.view_num }}
                      </div>
                    </div> -->
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <el-empty :image-size="200" v-else></el-empty>
        </div>
      </div>
    </div>
    <div class="no_data_loading" v-else>
      <div class="loading" v-if="loading">
        <i style="font-size: 50px" class="el-icon-loading"></i>
        <span>加载中....</span>
      </div>
      <el-empty v-else :description="error ? error : '暂无视频信息'"></el-empty>
    </div>
  </div>
</template>
<script>
import { tuijianlist } from "../../api/createCenter";
import videoApi from "../../api/popularScienceVideo";
export default {
  name: "popularScienceVideoDetail",
  data() {
    return {
      dialogVisibleImg: false,
      total: 12,
      tuijianLsit: [],
      detailVideo: {},
      loading: false,
      error: "",
    };
  },
  created() {
    this.videoDetail();
    // this.tuijianlistApi();
  },
  methods: {
    videoRecommend(item) {
      this.$router.push(`/popularScienceVideoDetail?id=${item.id}`);
      this.videoDetail();
    },
    //推荐列表
    async tuijianlistApi() {
      const res = await tuijianlist({ is_rec: 1, limit: 4, use_to_rec: "1" });
      this.tuijianLsit = res.data.datalist;
    },
    async videoDetail(id = this.$route.query ? this.$route.query.id : "") {
      if (!id) return;
      this.detailVideo = {};
      this.loading = true;
      this.error = "";
      try {
        let res = await videoApi.videoDetail(id);
        if (res.code == 1) {
          this.loading = false;
          this.detailVideo = res.data;
          this.detailVideo.create_time = this.detailVideo.create_time
            ? this.formatDate(this.detailVideo.create_time)
            : "";

          console.log(this.detailVideo, "this.detailVideo");
          if (
            this.detailVideo.recommend_article_list &&
            this.detailVideo.recommend_article_list.length
          ) {
            this.detailVideo.recommend_article_list.map((item) => {
              if (item.cover_img && !item.cover_img.includes("https")) {
                item.cover_img = `https://lib.api.medsky.cn${item.cover_img}`;
              }
              if (item.video_url && !item.video_url.includes("https")) {
                item.video_url = `https://lib.api.medsky.cn${item.video_url}`;
              }
            });
          }

          if (
            this.detailVideo.recommend_video_list &&
            this.detailVideo.recommend_video_list.length
          ) {
            this.detailVideo.recommend_video_list.map((item) => {
              if (item.cover_img && !item.cover_img.includes("https")) {
                item.cover_img = `https://lib.api.medsky.cn${item.cover_img}`;
              }
              if (item.video_url && !item.video_url.includes("https")) {
                item.video_url = `https://lib.api.medsky.cn${item.video_url}`;
              }
            });
          }

          let aaa = Date.now();
          console.log(this.formatDate(aaa), aaa);
        }
      } catch (error) {
        console.log(error);
        this.error = "获取用户信息出现问题";
      }
    },

    formatDate(time) {
      console.log(time, "time");
      let date = new Date(time * 1000);
      console.log(date, "date");
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;

      // const options = {
      //   weekday: "long",
      //   year: "numeric",
      //   month: "long",
      //   day: "numeric",
      // };
      // return date.toLocaleDateString("zh", options);
    },
  },
};
</script>
<style lang="less" scoped>
// :root {
//   --el-empty-fill-color-0: var(red) !important;
//   --el-empty-fill-color-1: blue;
//   --el-empty-fill-color-2: rgb(165, 165, 238) !important;
//   --el-empty-fill-color-3: #000000 !important;
//   --el-empty-fill-color-4: #da3232 !important;
//   --el-empty-fill-color-5: #9289e0 !important;
//   --el-empty-fill-color-6: #77c511 !important;
//   --el-empty-fill-color-7: #2876dd !important;
//   --el-empty-fill-color-8: #e9caca !important;
//   --el-empty-fill-color-9: #17eb92 !important;
// }
.popularScienceVideoDetail {
  // padding: 31px 357px 0 357px;
  display: flex;
  justify-content: center;
  .popularScienceVideoDetail_box {
    margin-top: 31px;
    width: 1206px;
  }
  .no_data_loading {
    padding: 100px 0;
    .loading {
      padding: 130px 0;
      display: flex;
      flex-direction: column;
      i {
        width: fit-content;
      }
      span {
        margin: 20px 0;
      }
    }
  }
  .video_player {
    margin: 40px 0 15px 0;
    background: #1b2127;
    // background-color: var(--bg-color);
    border-radius: 10px;
    overflow: hidden;
    padding: 10px;
    .video_info {
      display: flex;
      align-items: center;

      margin: 10px 0 20px 0;
      .left,
      .right {
        display: flex;
        flex-wrap: wrap;
      }
      .left {
        width: 100%;
      }
      // .right {
      //   width: 358px;
      // }
      .video_item:not(.video_item:last-child) {
        margin-right: 89px;
      }
      .author {
        margin: 5px 0px;
        span:nth-child(1) {
          width: 50px;
          white-space: nowrap;
        }
        span {
          font-size: 16px;
          color: #ffffff;
        }
      }
      .video_item {
        display: flex;
        // align-items: baseline;
        align-items: center;
        span {
          font-size: 16px;
          white-space: nowrap;
          color: #ffffff;
        }
        .title {
          margin-right: 5px;
        }
        .icon {
          // width: 16px;
          // height: 15px;
          height: 20px;
          margin-right: 5px;
        }
      }
    }
    .video_player_info {
      display: flex;
      justify-content: space-between;
      // .player_item {
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: space-between;
      // }
      .title {
        margin-bottom: 16px;
        color: #fff;
        font-size: 24px;
        font-weight: bold;
      }

      .left {
        // flex: 1;
        width: 830px;
        // height: 100%;
        margin-right: 20px;
        .video_box {
          // height: 100%;
          overflow: hidden;
          height: 503px;

          padding: 25px 0;
        }
        video {
          width: 100%;
          height: 100%;
          overflow: hidden;
          background: #000000;
          border-radius: 10px;
          box-sizing: border-box;
        }
      }
      .right {
        // width: 30%;
        width: 358px;
        .noEmpty {
          margin-top: 150px;
          // :deep(.el-empty__image) {
          //   svg {
          //     fill: var(--el-empty-fill-color-3) !important;
          //     display: none;
          //     path {
          //       fill: var(--el-empty-fill-color-3) !important;
          //     }
          //   }
          // }
        }
        .recommend_video_list {
          height: 500px;
          overflow-y: auto;
          .recommend_video_item:not(.recommend_video_item:last-child) {
            border-bottom: 1px dashed #cadae5;
            // margin-bottom: 20px;
          }
          .recommend_video_item:hover {
            .img_play {
              display: flex !important;
              align-items: center;
              justify-content: center;
            }
            .right_font {
              color: #6891ff !important;
            }
            // .left_video {
            //   .img {
            //     display: none;
            //   }
            //   .video {
            //     display: inline-block;
            //   }
            // }
          }
          .recommend_video_item {
            padding: 25px 0;
            cursor: pointer;
            display: flex;
            // align-items: center;
            .ellipsis_single_2 {
              height: 40px;
            }
            .ellipsis_single_3 {
              height: 60px;
            }
            .left_video {
              min-width: 133px;
              width: 133px;
              height: 75px;
              border-radius: 10px;
              overflow: hidden;
              position: relative;
              .img_play {
                display: none;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                // display: flex;
                // align-items: center;
                // justify-content: center;
              }
              // .img {
              //   display: inline-block;
              // }
              // .video {
              //   display: none;
              // }
              img {
                width: 100%;
                height: 100%;
              }
            }
            .right_font {
              // height: 63px;
              // height: 40px;
              margin-left: 9px;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
  .video_detail {
    display: flex;
    justify-content: space-between;
    .left {
      width: 830px;
      background: #fff;
      box-shadow: 0px 0px 10px 1px #e3ebf1;
      margin-right: 20px;
      padding: 32px;
      .title::before {
        content: "";
        width: 5px;
        height: 23px;
        display: inline-block;
        background: #2878ff;
        margin-right: 10px;
      }
      .title {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        // line-height: 27px;
        padding-bottom: 27px;
        border-bottom: 1px solid #f1f7fa;
        span {
          padding-bottom: 27px;
        }
      }
      .content {
        padding: 19px 5px;
        position: relative;
        width: 100%;
        * {
          width: 100% !important;
        }
      }
    }
    .right {
      // width: 358px;
      // margin-left: 45px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0px 0px 10px 1px #e3ebf1;
      padding: 20px;
      img {
        width: 72px;
        height: 28px;
        margin-bottom: 20px;
      }
    }
    .right-box {
      // background-color: #f4f8f8;
      // border: 1px solid #dce7ef;
      // border-radius: 9px;
      // padding: 20px;

      //列表
      .right-box-ul {
        .right-box-ul-li:not(.right-box-ul-li:last-child) {
          border-bottom: 1px dashed #cadae5;
        }
        .right-box-ul-li {
          width: 318px;
          box-sizing: border-box;
          background-color: #ffffff;
          padding: 18px;
          // border-radius: 9px;
          display: flex;
          margin-bottom: 20px;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            transform: scale(102%);
            box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.16);
          }
          &:last-child {
            margin-bottom: 0px !important;
          }
          .right-box-ul-li-img {
            width: 123px;
            height: 169px;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .right-box-ul-li-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .right-box-ul-li-right-text {
              // font-size: 14px;
              color: #1c1c1c;

              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 7;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .right-box-ul-li-right-bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .right-box-ul-li-right-bottom-zuo {
                color: #999999;
              }
              .right-box-ul-li-right-bottom-num {
                display: flex;
                align-items: center;
                .right-box-ul-li-right-bottom-num-img {
                  width: 18px;
                  height: 18px;
                  margin-right: 10px;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
                .right-box-ul-li-right-bottom-num-name {
                  color: #999999;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
